import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    props: true,
    meta: { layout: 'default' },
    // route level code-splitting
    // this generates a separate chunk (login.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  // シーズン一覧
  {
    path: '/',
    name: 'seasonHome',
    props: true,
    meta: { layout: 'default' },
    component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonHome.vue'),
  },
  // シーズン詳細
  {
    path: '/event/:topic_id/season/:season_id',
    name: 'seasonDetail',
    props: true,
    meta: { layout: 'default' },
    component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonDetail.vue'),
    children: [
      {
        path: '',
        name: 'seasonDetailHome',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonDetailHome.vue'),
      },
      // エントリーチーム一覧
      {
        path: 'team',
        name: 'seasonEntry',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonEntry.vue'),
      },
      // エントリーチーム詳細
      {
        path: 'team/:team_id',
        name: 'seasonEntryDetail',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonEntryDetail.vue'),
      },
      // 選手一覧・登録
      {
        path: 'team/:team_id/roster',
        name: 'seasonEntryRoster',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonEntryRoster.vue'),
      },
      // グループ作成
      {
        path: 'group/create',
        name: 'seasonGroupCreate',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGroupCreate.vue'),
      },
      // グループ分け
      {
        path: 'group/:group_id',
        name: 'seasonGroupDetail',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGroupDetail.vue'),
      },
      // 試合一覧
      {
        path: 'game',
        name: 'seasonGame',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGame.vue'),
      },
      // 試合情報
      {
        path: 'game/:game_id',
        name: 'seasonGameDetail',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGameDetail.vue'),
      },
      // 試合の流れ
      {
        path: 'game/:game_id/score',
        name: 'seasonGameScore',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGameScore.vue'),
      },
      // スコアボード
      {
        path: 'game/:game_id/score/board',
        name: 'seasonGameScoreboard',
        props: true,
        meta: { layout: 'none'},
        component: () => import(/* webpackChunkName: "season" */ '@/views/SeasonGameScoreboard.vue'),
      }
    ]
  },
  // チーム
  {
    path: '/team',
    name: 'team',
    props: true,
    meta: { layout: 'default' },
    component: () => import(/* webpackChunkName: "team" */ '@/views/Team.vue'),
    children: [
      // チーム詳細・選手一覧
      {
        path: ':team_id',
        name: 'teamDetail',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "team" */ '@/views/TeamDetail.vue'),
      }
    ]
  },
  // 選手
  {
    path: '/player',
    name: 'player',
    props: true,
    meta: { layout: 'default' },
    component: () => import(/* webpackChunkName: "player" */ '@/views/Player.vue'),
    children: [
      // 選手詳細
      {
        path: ':player_id',
        name: 'playerDetail',
        props: true,
        meta: { layout: 'default' },
        component: () => import(/* webpackChunkName: "player" */ '@/views/PlayerDetail.vue'),
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


import { VueCookieNext } from 'vue-cookie-next'

router.beforeEach((to, from, next) => {
  const toLoginPage = to.name === 'login'
  const isLoggedIn = VueCookieNext.getCookie('user_id') != null

  if (toLoginPage) {
    if (isLoggedIn) {
      next({ name: 'seasonHome' })
    } else {
      next()
    }
  } else {
    if (isLoggedIn) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

export default router
